import { Link } from 'react-router-dom';
import HiringCriteria from '../../components/HiringCriteria';
import TechStack from '../../components/TechStack';
import JobApplicationForm from './JobApplicationForm';

function SeniorSoftwareEngineer() {
  const position = {
    title: 'Senior Software Engineer',
    department: 'Engineering',
    location: 'Worldwide (Remote)',
    requirements: [
      '5+ years of experience in full-stack development',
      'Strong expertise in React, Node.js, and TypeScript',
      'Experience with cloud services (AWS/GCP)',
      'Background in e-commerce platforms',
      'Strong system design and architecture skills'
    ],
    levels: ['Senior'],
    requiresPortfolio: true,
    specificQuestions: {
      techExpertise: 'Are you an expert with full stack development (React, Node.js)?',
      aiExperience: 'Do you have experience creating AI features?'
    }
  };

  const responsibilities = [
    'Lead development of key platform features',
    'Design and implement scalable solutions',
    'Mentor junior developers',
    'Contribute to technical architecture decisions',
    'Ensure code quality and best practices',
    'Collaborate with cross-functional teams',
    'Participate in technical planning and sprint planning'
  ];

  const benefits = [
    'Competitive salary and equity package',
    'Remote-first work environment',
    'Health insurance coverage',
    'Professional development budget',
    'Latest equipment and tools',
    'Flexible working hours',
    'Regular team events and meetups'
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {/* Position Details */}
        <div className="bg-white rounded-lg shadow-xl overflow-hidden mb-8">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{position.title}</h1>
            <p className="text-gray-500 mb-6">{position.department} • {position.location}</p>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">Requirements:</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {position.requirements.map((req, idx) => (
                  <li key={idx}>{req}</li>
                ))}
              </ul>
            </div>

            {/* Apply Button */}
            <Link
              to={`/careers/${position.title.toLowerCase().replace(/\s+/g, '-')}/apply`}
              className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-[#0049ac] rounded-lg hover:bg-[#0049ac]/90 hover:scale-105 transform transition-all duration-300"
            >
              Submit Application
            </Link>
          </div>
        </div>
      </div>

      {/* Pass the entire position object */}
      <JobApplicationForm position={position} />
    </div>
  );
}

export default SeniorSoftwareEngineer;